import ProjectActivationConfig from './ProjectActivationConfig'

export default ProjectActivationConfig
